import React from 'react';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';

const HubControls = ({ sortOption, setSortOption, searchTerm, setSearchTerm, filterTier, setFilterTier, isSelectMode, onToggleSelectMode, onShowMyCode }) => {
    const { t } = useTranslation();
    const TIER_OPTIONS = ['All Tiers', 'Inner Circle', 'Acquaintance', 'Following'];

    return (
        <div className="flex flex-col sm:flex-row justify-between items-center mb-4 px-2 gap-4">
            {/* Left side: Action buttons */}
            <div className="flex items-center gap-2">
                <button 
                    onClick={onToggleSelectMode}
                    className={`text-sm font-semibold px-4 py-1.5 rounded-md ${isSelectMode ? 'bg-red-600 text-white' : 'bg-gray-700 text-gray-200'}`}>
                    {isSelectMode ? t('hubControls.cancel') : t('hubControls.select')}
                </button>
                <button 
                    onClick={onShowMyCode}
                    className={`text-sm font-semibold px-4 py-1.5 rounded-md bg-purple-600 text-white flex items-center gap-2`}>
                    <LucideIcons.QrCode size={16} />
                    <span>{t('hubControls.myCode')}</span>
                </button>
            </div>

            {/* Right side: Search, Filter, Sort */}
            <div className="flex items-center gap-4">
                {/* Search Input */}
                <div className="relative flex-grow w-full sm:max-w-xs">
                    <LucideIcons.Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" />
                    <input 
                        type="text"
                        placeholder={t('hubControls.searchPlaceholder')}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="bg-gray-700/50 border border-gray-600 rounded-md pl-10 pr-4 py-1.5 w-full text-sm text-white focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500"
                    />
                </div>
                {/* Filter Dropdown */}
                <div className="flex items-center gap-2">
                    <div className="relative">
                        <select
                            id="filter-select"
                            value={filterTier}
                            onChange={(e) => setFilterTier(e.target.value)}
                            className="bg-gray-700/50 border border-gray-600 rounded-md pl-3 pr-8 py-1.5 text-sm text-white focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 appearance-none"
                        >
                            {TIER_OPTIONS.map(tier => <option key={tier} value={tier}>{t(`hubControls.tiers.${tier.toLowerCase().replace(' ', '')}`)}</option>)}
                        </select>
                        <LucideIcons.ChevronDown size={16} className="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" />
                    </div>
                </div>

                {/* Sort Dropdown */}
                <div className="flex items-center gap-2">
                    <div className="relative">
                        <select
                            id="sort-select"
                            value={sortOption}
                            onChange={(e) => setSortOption(e.target.value)}
                            className="bg-gray-700/50 border border-gray-600 rounded-md pl-3 pr-8 py-1.5 text-sm text-white focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 appearance-none"
                        >
                            <option value="strength">{t('hubControls.sortOptions.strength')}</option>
                            <option value="alphabetical">{t('hubControls.sortOptions.alphabetical')}</option>
                            <option value="lastActive">{t('hubControls.sortOptions.lastActive')}</option>
                        </select>
                        <LucideIcons.ChevronDown size={16} className="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HubControls;
